import { lazy } from "react";
import MainContent from "../Components/MainContent/MainContent";
import Stock from "../Components/Stock/Stock";

const AboutUs = lazy(() => import("../Components/AboutUs/AboutUs"));
const WarrantyContent = lazy(
  () => import("../Components/Warranty/WarrantyContent")
);
const TransactionCarDetail = lazy(
  () => import("../Components/TodayTransaction/Operations/TransactionCarDetail")
);
const AppErrorPayment = lazy(
  () => import("../Components/Application/ErrorPayment")
);
const IosErrorPayment = lazy(
  () => import("../Components/Application/IosErrorPayment")
);
const IosSuccessCreditPayment = lazy(
  () => import("../Components/Application/IosSuccessCreditPayment")
);
const IosSuccessPayment = lazy(
  () => import("../Components/Application/IosSuccessPayment")
);
const SuccessCreditPayment = lazy(
  () => import("../Components/Application/SuccessCreditPayment")
);
const AppSuccessPayment = lazy(
  () => import("../Components/Application/SuccessPayment")
);
const CompaireAdvertises = lazy(
  () => import("../Components/CompaireAdvertises/CompaireAdvertises")
);
const ContactUs = lazy(() => import("../Components/ContactUs/ContactUs"));
const ExpertContent = lazy(() => import("../Components/Expert/ExpertContent"));
const FaqContents = lazy(() => import("../Components/FaqContents/FaqContents"));
const Suggestion = lazy(
  () => import("../Components/Footer/Suggestion/Suggestion")
);
const ForgetPass = lazy(() => import("../Components/ForgetPass/ForgetPass"));
const Login = lazy(() => import("../Components/Login/Login"));
const ManaPrices = lazy(() => import("../Components/ManaPrices/ManaPrices"));
const ManaRules = lazy(() => import("../Components/ManaRules/ManaRules"));
const MyCars = lazy(() => import("../Components/MyCars/MyCars"));
const MyFavouriteOrders = lazy(
  () => import("../Components/MyFavouriteOrders/MyFavouriteOrders")
);
const MyProfile = lazy(() => import("../Components/MyProfile/MyProfile"));
const MyPurchaseOrders = lazy(
  () => import("../Components/MyPurchaseOrders/MyPurchaseOrders")
);
const MyReservations = lazy(
  () => import("../Components/MyReservations/MyReservations")
);
const MySalesOrders = lazy(
  () => import("../Components/MySalesOrders/MySalesOrders")
);
const NewCar = lazy(() => import("../Components/NewCar/NewCar"));
const ErrorPayment = lazy(
  () => import("../Components/PayResults/ErrorPayment")
);
const SuccessPayment = lazy(
  () => import("../Components/PayResults/SuccessPayment")
);
const SuccessRaise = lazy(
  () => import("../Components/PayResults/SuccessRaise")
);
const PriceEstimation = lazy(
  () => import("../Components/PriceEstimation/PriceEstimationForm")
);
const Privacy = lazy(() => import("../Components/Privacy/Privacy"));
const PurchaseContent = lazy(
  () => import("../Components/PurchaseContent/PurchaseContent")
);
const OfferPrice = lazy(
  () => import("../Components/PurchaseOrder/OfferPrice/OfferPrice")
);
const PurchaseCarDetail = lazy(
  () =>
    import("../Components/PurchaseOrder/PurchaseCarDetail/PurchaseCarDetail")
);
const PurchaseCarResevation = lazy(
  () =>
    import(
      "../Components/PurchaseOrder/PurchaseCarReservation/PurchaseCarReservation"
    )
);
const PurchaseOrderForm = lazy(
  () =>
    import("../Components/PurchaseOrder/PurchaseOrderForm/PurchaseOrderForm")
);
const RaiseCredit = lazy(() => import("../Components/RaiseCredit/RaiseCredit"));
const RegisterPurchaseOrder = lazy(
  () => import("../Components/RegisterPurchaseOrder/RegisterPurchaseOrder")
);
const SaleContent = lazy(() => import("../Components/SaleContent/SaleContent"));
const CarInfo = lazy(
  () => import("../Components/SalesOrder/SalesOrderForm/CarInfo/CarInfo")
);
const SalesOrderDoc = lazy(
  () => import("../Components/SalesOrder/SalesOrderForm/Document/Document")
);
const Expert = lazy(
  () => import("../Components/SalesOrder/SalesOrderForm/Expert/Expert")
);
const SalesOrderComment = lazy(
  () =>
    import("../Components/SalesOrder/SalesOrderForm/OrderComment/OrderComment")
);
const SalesOrderForm = lazy(
  () => import("../Components/SalesOrder/SalesOrderForm/SalesOrderForm")
);
const SampleFile = lazy(() => import("../Components/SampleFile/SampleFile"));
const SignUp = lazy(() => import("../Components/SignUp/SignUp"));
const AllTransactions = lazy(
  () => import("../Components/AllTransactions/AllTransactions")
);
const Units = lazy(() => import("../Components/Units/Units"));
const Information = lazy(() => import("../Components/Information/Information"));
const FacilitiesForm = lazy(
  () => import("../Components/Facilities/FacilitiesForm/FacilitiesForm")
);
const Introducing = lazy(() => import("../Components/Introducing/Introducing"));
const JobOpportunities = lazy(
  () => import("../Components/JobOpportunities/JobOpportunities")
);
const JobOpportunityList = lazy(
  () => import("../Components/JobOpportunities/JobOpportunityList")
);
const jobProjMarketer = lazy(
  () => import("../Components/JobOpportunities/ProjMarketer")
);
const ShowroomSecretary = lazy(
  () => import("../Components/JobOpportunities/ShowroomSecretary")
);
const FullStackDev = lazy(
  () => import("../Components/JobOpportunities/FullStackDev")
);
const PhpDev = lazy(() => import("../Components/JobOpportunities/PhpDev"));
const UiDesigner = lazy(
  () => import("../Components/JobOpportunities/UiDesigner")
);
const Announcements = lazy(
  () => import("../Components/Announcements/Announcements")
);
const PriceChanges = lazy(
  () => import("../Components/PriceChanges/PriceChanges")
);
const CompairCarsList = lazy(
  () => import("../Components/CompairCars/CompairCarsList")
);
const CarDetails = lazy(() => import("../Components/CarDetails/CarDetails"));
const CompairCarDetails = lazy(
  () => import("../Components/CompairCarDetails/CompairCarDetails")
);
const LetMeKnow = lazy(
  () => import("../Components/Toolbar/LetMeKnow")
);

const routes = [
  { path: "/", component: MainContent },
  // { path: "/expert-order", component: ExpertOrderForm },
  { path: "/sell", component: SalesOrderForm, byLogin: false },
  { path: "/sell-info", component: CarInfo, byLogin: false },
  { path: "/estimation", component: PriceEstimation, byLogin: false },
  { path: "/purchase-order", component: PurchaseOrderForm, byLogin: false },
  { path: "/cmp-purchase-order", component: PurchaseOrderForm, byLogin: false },
  {
    path: "/my-favourites-orders",
    component: MyFavouriteOrders,
    byLogin: false,
  },
  {
    path: "/register-purchase-order",
    component: RegisterPurchaseOrder,
    byLogin: true,
  },
  { path: "/sign-in", component: Login, byLogin: false },
  { path: "/sign-up", component: SignUp, byLogin: false },
  { path: "/forget-pass", component: ForgetPass, byLogin: false },
  { path: "/sell-docs", component: SalesOrderDoc, byLogin: false },
  { path: "/sell-expert", component: Expert, byLogin: false },
  { path: "/sell-cm", component: SalesOrderComment, byLogin: false },
  {
    path: "/purchase-car-details",
    component: PurchaseCarDetail,
    byLogin: false,
  },
  {
    path: "/transaction-car-details",
    component: TransactionCarDetail,
    byLogin: false,
  },
  {
    path: "/purchase-car-reserve",
    component: PurchaseCarResevation,
    byLogin: false,
  },
  { path: "/offer-price", component: OfferPrice, byLogin: false },
  { path: "/my-profile", component: MyProfile, byLogin: false },
  { path: "/my-reservations", component: MyReservations, byLogin: false },
  { path: "/about-us", component: AboutUs, byLogin: false },
  { path: "/contact-us", component: ContactUs, byLogin: false },
  { path: "/privacy", component: Privacy, byLogin: false },
  { path: "/my-reservations", component: MyReservations, byLogin: false },
  { path: "/my-cars", component: MyCars, byLogin: false },
  { path: "/my-sales-orders", component: MySalesOrders, byLogin: false },
  { path: "/my-purchase-orders", component: MyPurchaseOrders, byLogin: false },
  { path: "/scs-pay", component: SuccessPayment, byLogin: false },
  { path: "/err-pay", component: ErrorPayment, byLogin: false },
  { path: "/scs-rs-crt", component: SuccessRaise, byLogin: false },
  { path: "/err-rs-crt", component: ErrorPayment, byLogin: false },
  { path: "/app-pay-success", component: AppSuccessPayment, byLogin: false },
  {
    path: "/app-credit-success",
    component: SuccessCreditPayment,
    byLogin: false,
  },
  { path: "/app-pay-error", component: AppErrorPayment, byLogin: false },
  { path: "/ios-pay-success", component: IosSuccessPayment, byLogin: false },
  {
    path: "/ios-credit-success",
    component: IosSuccessCreditPayment,
    byLogin: false,
  },
  { path: "/ios-pay-error", component: IosErrorPayment, byLogin: false },
  { path: "/new-car", component: NewCar, byLogin: false },
  { path: "/raise-credit", component: RaiseCredit, byLogin: false },
  { path: "/mana-prices", component: ManaPrices, byLogin: false },
  { path: "/faq", component: FaqContents, byLogin: false },
  { path: "/cmpr-ad", component: CompaireAdvertises, byLogin: false },
  { path: "/prchs-cntnt", component: PurchaseContent, byLogin: false },
  { path: "/sls-cntnt", component: SaleContent, byLogin: false },
  { path: "/rules", component: ManaRules, byLogin: false },
  { path: "/expert", component: ExpertContent, byLogin: false },
  { path: "/warranty", component: WarrantyContent, byLogin: false },
  { path: "/mana-forms", component: SampleFile, byLogin: false },
  { path: "/sug", component: Suggestion, byLogin: false },
  { path: "/price-estimate", component: PriceEstimation, byLogin: false },
  { path: "/all-trns", component: AllTransactions, byLogin: false },
  { path: "/unts", component: Units, byLogin: false },
  { path: "/info", component: Information, byLogin: false },
  { path: "/fac-form", component: FacilitiesForm, byLogin: false },
  { path: "/intro-to-others", component: Introducing, byLogin: false },
  { path: "/job-opportunity", component: JobOpportunities, byLogin: false },
  {
    path: "/job-opportunity-list",
    component: JobOpportunityList,
    byLogin: false,
  },
  { path: "/job-pro-marketer", component: jobProjMarketer, byLogin: false },
  { path: "/showroom-secretary", component: ShowroomSecretary, byLogin: false },
  { path: "/fullStack-dev", component: FullStackDev, byLogin: false },
  { path: "/php-dev", component: PhpDev, byLogin: false },
  { path: "/ui-dsgnr", component: UiDesigner, byLogin: false },
  { path: "/stock", component: Stock, byLogin: false },
  { path: "/announcmnts", component: Announcements, byLogin: false },
  { path: "/price-chngs", component: PriceChanges, byLogin: false },
  { path: "/compre-cars", component: CompairCarsList, byLogin: false },
  { path: "/car-dtls", component: CarDetails, byLogin: false },
  { path: "/cmpr-car-dtls", component: CompairCarDetails, byLogin: false },
  { path: "/LetMeKnow", component: LetMeKnow, byLogin: false },
];

export default routes;
